// game-objects
import { SkyAnticipation, SkyLineText, SkyReel, SkyReels, SkySlotSounds } from "@aceroll/core";

import { Grid } from './grid';

export const config = {
    gridConstructor: Grid,
    reelsConstructor: SkyReels,
    soundsConstructor: SkySlotSounds,
    grid: {
        // move this to the extra
        text: {
            lineTextConstructor: SkyLineText,
            fontType: 'bitmap',
            src: 'font_4'
        },
        // and this
        winFormulaText: {
            lineTextConstructor: SkyLineText,
            fontType: 'bitmap',
            fontSize: 50,
            src: 'font_4'
        },
        // and this
        anticipation: {
            anticipationConstructor: SkyAnticipation,
            transforms: {
                position: {
                    x: 0,
                    y: 385
                },
                scale: {
                    x: 0.8,
                    y: 0.8
                }
            },
            default: {
                spine: {
                    src: 'spine-anticipation',
                    animations: {
                        in: 'anticipation_in',
                        loop: 'anticipation_loop',
                        out: 'anticipation_out'
                    },
                    skin: null
                }
            }
        },
        transforms: {
            landscape: {
                position: {
                    x: 468,
                    y: 551
                }
            },
            portrait: {
                position: {
                    x: 468,
                    y: 549
                }
            }
        },
        verticalGap: 0,
        horizontalGap: 8,
        cellsSize: {
            width: 192,
            height: 192
        },
        reels: [
            {
                reelConstructor: SkyReel,
                cellsAmount: 4,
                shift: {
                    x: 0,
                    y: 0
                }
            },
            {
                reelConstructor: SkyReel,
                cellsAmount: 4,
                shift: {
                    x: 0,
                    y: 0
                }
            },
            {
                reelConstructor: SkyReel,
                cellsAmount: 4,
                shift: {
                    x: 0,
                    y: 0
                }
            },
            {
                reelConstructor: SkyReel,
                cellsAmount: 4,
                shift: {
                    x: 0,
                    y: 0
                }
            },
            {
                reelConstructor: SkyReel,
                cellsAmount: 4,
                shift: {
                    x: 0,
                    y: 0
                }
            }
        ]
    },
    behaviour: {
        spin: {
            reelStartDelays: {
                default: [
                    0,
                    150,
                    250,
                    300,
                    350
                ],
                turbo: [
                    0,
                    100,
                    150,
                    200,
                    250
                ],
                superTurbo: [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                lightingTurbo: [
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            reelStopDelays: {
                default: [
                    0,
                    250,
                    450,
                    600,
                    700
                ],
                turbo: [
                    0,
                    150,
                    270,
                    360,
                    420
                ],
                superTurbo: [
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                lightingTurbo: [
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            },
            transition: {
                default: {
                    minDuration: 800,
                    stepDuration: 25,
                    startDuration: 75,
                    endDuration: 700,
                    startEase: 'linear',
                    endEase: 'back.out(4)'
                },
                turbo: {
                    minDuration: 400,
                    stepDuration: 18,
                    startDuration: 54,
                    endDuration: 504,
                    startEase: 'linear',
                    endEase: 'back.out(1.7)'
                },
                superTurbo: {
                    minDuration: 0,
                    stepDuration: 12,
                    startDuration: 300,
                    endDuration: 48,
                    startEase: 'back.in(4)',
                    endEase: 'linear'
                },
                lightingTurbo: {
                    minDuration: 0,
                    stepDuration: 8,
                    startDuration: 200,
                    endDuration: 36,
                    startEase: 'back.in(1.7)',
                    endEase: 'linear'
                }
            }
        },
        anticipation: {
            transition: {
                default: {
                    minDuration: 1200,
                    stepDuration: 16,
                    startEase: 'linear',
                    endEase: 'back.out(4)'
                },
                turbo: {
                    minDuration: 800,
                    stepDuration: 12,
                    startEase: 'linear',
                    endEase: 'back.out(1.7)'
                },
                superTurbo: {
                    minDuration: 0,
                    stepDuration: 12,
                    startEase: 'linear',
                    endEase: 'back.out(1.7)'
                },
                lightingTurbo: {
                    minDuration: 0,
                    stepDuration: 8,
                    startEase: 'linear',
                    endEase: 'linear'
                }
            }
        }
    },
    sounds: {
        anticipation: 'reel_antisipation',
        roll_spin: null,
        start: {
            default: null,
            turbo: null,
            superTurbo: null,
            lightingTurbo: null
        },
        finish: {
            default: null,
            turbo: null,
            superTurbo: null,
            lightingTurbo: null
        },
        reels: [
            {
                start: {
                    default: 'slot_spin_roll',
                    turbo: 'slot_spin_roll',
                    superTurbo: null,
                    lightingTurbo: null
                },
                finish: {
                    default: 'reelstop_1',
                    turbo: 'reelstop_1',
                    superTurbo: null,
                    lightingTurbo: null
                }
            },
            {
                start: {
                    default: 'slot_spin_roll',
                    turbo: 'slot_spin_roll',
                    superTurbo: null,
                    lightingTurbo: null
                },
                finish: {
                    default: 'reelstop_2',
                    turbo: 'reelstop_2',
                    superTurbo: null,
                    lightingTurbo: null
                }
            },
            {
                start: {
                    default: 'slot_spin_roll',
                    turbo: 'slot_spin_roll',
                    superTurbo: null,
                    lightingTurbo: null
                },
                finish: {
                    default: 'reelstop_3',
                    turbo: 'reelstop_3',
                    superTurbo: null,
                    lightingTurbo: null
                }
            },
            {
                start: {
                    default: 'slot_spin_roll',
                    turbo: 'slot_spin_roll',
                    superTurbo: null,
                    lightingTurbo: null
                },
                finish: {
                    default: 'reelstop_4',
                    turbo: 'reelstop_4',
                    superTurbo: null,
                    lightingTurbo: null
                }
            },
            {
                start: {
                    default: 'slot_spin_roll',
                    turbo: 'slot_spin_roll',
                    superTurbo: 'slot_spin_roll',
                    lightingTurbo: 'slot_spin_roll'
                },
                finish: {
                    default: 'reelstop_5',
                    turbo: 'reelstop_5',
                    superTurbo: 'reelstop_5',
                    lightingTurbo: 'reelstop_5'
                }
            }
        ]
    },
    defaults: {
        symbols: {
            default: [
                [1, 4, 5, 1],
                [5, 6, 7, 3],
                [6, 7, 8, 10],
                [5, 4, 3, 10],
                [2, 5, 2, 4]
            ],
            bonus_1: [
                [1, 4, 5, 1],
                [5, 6, 7, 3],
                [6, 7, 8, 10],
                [5, 4, 3, 10],
                [2, 5, 2, 4]
            ],
            bonus_2: [
                [1, 4, 5, 1],
                [5, 6, 7, 3],
                [6, 7, 8, 10],
                [5, 4, 3, 10],
                [2, 5, 2, 4]
            ]
        },
        fakeSymbols: {
            default: [
                [8, 2, 6],
                [4, 7, 5],
                [6, 3, 8],
                [2, 8, 7],
                [4, 5, 3]
            ],
            bonus_1: [
                [8, 2, 6],
                [4, 7, 5],
                [6, 3, 8],
                [2, 8, 7],
                [4, 5, 3]
            ],
            bonus_2: [
                [8, 2, 6],
                [4, 7, 5],
                [6, 3, 8],
                [2, 8, 7],
                [4, 5, 3]
            ]
        }
    }
}